import { saveAs } from 'file-saver';
import { call, put } from 'redux-saga/effects';

import { ActionPromise } from 'bus/rootActions';

import { ApiReport } from '../../../../services';
import { global_error_handler } from '../../../../utils/global-error-handler';
import { makeRequestWithSpinner } from '../../../../worker';
import {
  comingNomenclatureReport,
  getInvoice,
  getReportPassport,
  getTtnParameters,
  setInvoice,
  setReportPassport,
  setTtn,
} from '../../actions';
import {
  InvoiceParamsRequestPreInfo,
  ReportPassport,
  ReportPassportRequest,
  SetReportPassportRequest,
  TtnParameter,
  TtnParameterSetRequest,
} from '../../types';

export function* fetchTtnParametersCurrent(action: any): Generator {
  try {
    const options = {
      fetcher: ApiReport.getReportTtnParameters,
      startFetching: getTtnParameters.start,
      stopFetching: getTtnParameters.stop,
      fill: getTtnParameters.fill,
      setErrorAction: getTtnParameters.error,
      fetcherParam: action.payload,
    };

    const result = yield makeRequestWithSpinner<
      TtnParameter,
      Pick<TtnParameterSetRequest, 'requestWorkId' | 'version'>
    >(options);
    yield action.resolve(result);
  } catch (e) {}
}

export function* fetchTtnOpen(action: any): Generator {
  try {
    yield put(setTtn.start());

    const result: any = yield call(ApiReport.setReportTtn, action.payload);
    yield put(setTtn.stop());
    let filename = result.headers['content-disposition'].split('filename=')[1].split(';')[0];
    filename = decodeURI(filename).replaceAll('+', ' ');
    saveAs(result.data, filename);
  } catch (error: any) {
    let status = error.response.status;
    let responseObj: any = yield error.response.data.text();
    if (error.response && status && responseObj) {
      global_error_handler({ response: { status, data: JSON.parse(responseObj) } });
    } else {
      global_error_handler(error);
    }
  }
}

export function* comingNomenclatureReportWorker(action: any): Generator {
  try {
    yield put(comingNomenclatureReport.start());

    const result: any = yield call(ApiReport.comingNomenclatureReport, action.payload);
    let filename = result.headers['content-disposition'].split('filename=')[1].split(';')[0];
    filename = decodeURI(filename).replaceAll('+', ' ');
    saveAs(result.data, filename);
  } catch (error: any) {
    let status = error.response?.status || '';
    let responseObj: any = yield error.response?.data.text();
    if (error && error.response && status && responseObj) {
      global_error_handler({ response: { status, data: JSON.parse(responseObj) } });
    } else {
      global_error_handler(error);
    }
  } finally {
    yield action.resolve();
    yield put(comingNomenclatureReport.stop());
  }
}

export function* fetchInvoiceParametersCurrent(action: any): Generator {
  try {
    const options = {
      fetcher: ApiReport.getComingInvoiceParams,
      startFetching: getInvoice.start,
      stopFetching: getInvoice.stop,
      fill: getInvoice.fill,
      setErrorAction: getInvoice.error,
      fetcherParam: action.payload,
    };

    const result = yield makeRequestWithSpinner<any, InvoiceParamsRequestPreInfo>(options);
    yield action.resolve(result);
  } catch (e) {}
}

export function* comingInvoiceReportWorker(action: any): Generator {
  try {
    yield put(setInvoice.start());

    const result: any = yield call(ApiReport.comingInvoiceReport, action.payload);
    let filename = result.headers['content-disposition'].split('filename=')[1].split(';')[0];
    filename = decodeURI(filename).replaceAll('+', ' ');
    saveAs(result.data, filename);
  } catch (error: any) {
    let status = error.response?.status || '';
    let responseObj: any = yield error.response?.data.text();
    if (error && error.response && status && responseObj) {
      global_error_handler({ response: { status, data: JSON.parse(responseObj) } });
    } else {
      global_error_handler(error);
    }
  } finally {
    yield put(setInvoice.stop());
  }
}

export function* fetchReportPassportWorker(action: ActionPromise<ReportPassport, ReportPassportRequest>): Generator {
  try {
    const options = {
      fetcher: ApiReport.getReportPassport,
      startFetching: getReportPassport.start,
      stopFetching: getReportPassport.stop,
      fill: getReportPassport.fill,
      setErrorAction: getReportPassport.error,
      fetcherParam: action.payload,
    };

    const result = yield makeRequestWithSpinner<ReportPassport, ReportPassportRequest>(options);
    yield action.resolve(result as ReportPassport);
  } catch (e) {}
}

export function* fetchSetReportPassportWorker(action: ActionPromise<Blob, SetReportPassportRequest>): Generator {
  try {
    yield put(setReportPassport.start());

    const result: any = yield call(ApiReport.setReportPassport, action.payload);
    let filename = result.headers['content-disposition'].split('filename=')[1].split(';')[0];
    filename = decodeURI(filename).replaceAll('+', ' ');
    saveAs(result.data, filename);
  } catch (error: any) {
    let status = error.response?.status || '';
    let responseObj: any = yield error.response?.data.text();
    if (error && error.response && status && responseObj) {
      global_error_handler({ response: { status, data: JSON.parse(responseObj) } });
    } else {
      global_error_handler(error);
    }
  } finally {
    yield put(setReportPassport.stop());
  }
}
